import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "1b088e13-8675-4efa-a3d6-8add2f52944c",
  publicId: "17",
  name: "Diffraction",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, principle02, task01],
};

export default lesson;
